import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { Link, useLocation } from 'react-router-dom';
import { OrderModal } from './OrderModal';
import { useLanguage } from '../utils/i18n';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const location = useLocation();
  const {
    t,
    language,
    setLanguage
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: t('nav_home'),
    href: '/'
  }, {
    name: t('nav_catalog'),
    href: '/catalog'
  }, {
    name: t('nav_partner'),
    href: '/partner'
  }, {
    name: t('nav_contact'),
    href: '/contact'
  }];
  const isHome = location.pathname === '/';
  const isTransparent = isHome && !isScrolled;
  // If not home, header should always have background or be visible
  const headerBg = isTransparent ? 'bg-gradient-to-b from-black/60 via-black/30 to-transparent' : 'bg-white/90 backdrop-blur-md shadow-md';
  const textColor = isTransparent ? 'text-white' : 'text-gray-900';
  const navHover = isTransparent ? 'hover:text-red-400' : 'hover:text-red-600';
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-2 ${headerBg}`} data-id="element-214">
        
        <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-215">
          <div className="flex items-center justify-between" data-id="element-216">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 group" data-id="element-217">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hyseuuq2warchstz2tvf3s/f7c74e3b-3f4e-439c-8223-13536fb8e81c/YB_A1.svg" alt="Yavuz Burak Logo" className="h-12 w-auto object-contain" data-id="element-218" />
              
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8" data-id="element-219">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium uppercase tracking-wider transition-colors ${textColor} ${navHover} ${location.pathname === link.href ? 'text-red-500' : ''}`} data-id="element-220">
                
                  {link.name}
                </Link>)}
            </nav>

            {/* CTA & Mobile Toggle */}
            <div className="flex items-center gap-4" data-id="element-221">
              <div className="hidden md:flex items-center gap-4" data-id="element-222">
                <div className="flex items-center gap-1 bg-black/10 rounded-sm p-0.5" data-id="element-223">
                  <button onClick={() => setLanguage('ru')} className={`px-2 py-1 text-xs font-bold rounded-sm transition-colors ${language === 'ru' ? isTransparent ? 'bg-white/20 text-white' : 'bg-gray-200 text-gray-900' : `${textColor} opacity-70 hover:opacity-100`}`} data-id="element-224">
                    
                    RU
                  </button>
                  <button onClick={() => setLanguage('ky')} className={`px-2 py-1 text-xs font-bold rounded-sm transition-colors ${language === 'ky' ? isTransparent ? 'bg-white/20 text-white' : 'bg-gray-200 text-gray-900' : `${textColor} opacity-70 hover:opacity-100`}`} data-id="element-225">
                    
                    KY
                  </button>
                </div>

                <a href="tel:+996502100636" className={`flex items-center gap-2 text-sm font-medium ${textColor}`} data-id="element-226">
                  
                  <Phone className="h-4 w-4" data-id="element-227" />
                  <span data-id="element-228">+996 502 100 636</span>
                </a>
                <Button size="sm" variant={isHome && !isScrolled ? 'outline' : 'primary'} className={isHome && !isScrolled ? 'border-white text-white hover:bg-white hover:text-red-600' : ''} onClick={() => setIsOrderModalOpen(true)} data-id="element-229">
                  
                  {t('btn_contact')}
                </Button>
              </div>

              <button className={`md:hidden p-2 ${textColor}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-230">
                
                {isMobileMenuOpen ? <X data-id="element-231" /> : <Menu data-id="element-232" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 p-4 flex flex-col gap-4 animate-in slide-in-from-top-5" data-id="element-233">
            <div className="flex items-center gap-2 mb-2" data-id="element-234">
              <button onClick={() => setLanguage('ru')} className={`flex-1 py-2 text-sm font-bold rounded-sm transition-colors ${language === 'ru' ? 'bg-gray-200 text-gray-900' : 'bg-gray-50 text-gray-500 hover:bg-gray-100'}`} data-id="element-235">
              
                Русский
              </button>
              <button onClick={() => setLanguage('ky')} className={`flex-1 py-2 text-sm font-bold rounded-sm transition-colors ${language === 'ky' ? 'bg-gray-200 text-gray-900' : 'bg-gray-50 text-gray-500 hover:bg-gray-100'}`} data-id="element-236">
              
                Кыргызча
              </button>
            </div>

            {navLinks.map(link => <Link key={link.name} to={link.href} className="text-gray-900 font-medium py-2 border-b border-gray-100 last:border-0" data-id="element-237">
            
                {link.name}
              </Link>)}
            <Button className="w-full mt-2" onClick={() => setIsOrderModalOpen(true)} data-id="element-238">
            
              {t('btn_contact_us')}
            </Button>
          </div>}
      </header>

      <OrderModal isOpen={isOrderModalOpen} onClose={() => setIsOrderModalOpen(false)} data-id="element-239" />
      
    </>;
}